module.exports = __webpack_public_path__ + "static/media/internal_env_4_media_12.0a47e9e5.webp";